module.exports = __webpack_public_path__ + "static/img/W.04edb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/W.png
// module id = OVu3
// module chunks = 0